import React from "react";
import { Field } from "react-final-form";
import { DropzoneInput } from "../../../components/inputs/final_form/DropzoneInput";
import { atLeastOneFieldRequired } from "../../../util/validators";
import { SftpSettingModal } from "./SftpSettingsModal";

export const AddSftpSettingModal = ({ resourceId, resourcePath, onAdd }) => {
  return (
    <SftpSettingModal
      resourceId={resourceId}
      resourcePath={resourcePath}
      onAction={onAdd}
      sftp={null}
      toggleButtonLabel="Add SFTP Server Configuration"
      actionTitle="Add"
      keyfileInput={
        <Field
          required
          validate={atLeastOneFieldRequired("password")}
          component={DropzoneInput}
          accept={null}
          hint="Drop Keyfile"
          label="Keyfile"
          name="keyfile"
        />
      }
    />
  );
};
